import { NumberInput, NumberInputProps } from "@mantine/core";
import { useCallback } from "react";

interface ProductCodeInputProps
  extends Omit<NumberInputProps, "value" | "onChange"> {
  label: string;
  name: string;
  maxLength?: number; // optional digit length
  value: number | undefined;
  setValue: (val: number | undefined) => void;
  resetPage?: () => void;
}

const ProductCodeInput = ({
  name,
  label,
  value,
  setValue,
  resetPage,
  maxLength,
  ...rest
}: ProductCodeInputProps) => {
  const handleChange = useCallback(
    (val: string | number) => {
      const parsed = typeof val === "number" ? val : parseInt(val);
      const next = isNaN(parsed) ? undefined : parsed;

      // Enforce digit length if maxLength is set
      if (
        typeof next === "number" &&
        maxLength &&
        next.toString().length > maxLength
      )
        return;

      if (value !== next && resetPage) resetPage();
      setValue(next);
    },
    [value, setValue, resetPage, maxLength]
  );

  return (
    <NumberInput
      name={name}
      label={label}
      title={label}
      value={value ?? ""}
      onChange={handleChange}
      hideControls
      {...rest}
    />
  );
};

export default ProductCodeInput;
